import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Enviar arquivo"), -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, /*#__PURE__*/_toDisplayString("Selecionar arquivo para enviar"), -1)
const _hoisted_3 = {
  key: 1,
  class: "border p-6 h-32 flex flex-col gap-2"
}
const _hoisted_4 = { class: "bg-h-primary-50 w-48 sm:w-52 md:w-72 p-3 rounded-sm flex flex-row gap-2" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Comentários"), -1)
const _hoisted_7 = { class: "flex flex-row gap-2 items-center mb-4" }
const _hoisted_8 = { class: "flex flex-row-reverse gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    class: "flex flex-col gap-4"
  }, [
    _hoisted_1,
    (!_ctx.form?.file)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: "input-student-activity",
          class: _normalizeClass(["border border-dashed p-6 h-32 flex flex-col justify-center items-center", [{ 'border border-h-error-500': _ctx.v$?.form?.file?.$error }]])
        }, [
          _createVNode(_component_v_icon, {
            name: "bi-file-earmark-arrow-up",
            scale: 2
          }),
          _hoisted_2,
          _createElementVNode("input", {
            type: "file",
            class: "hidden",
            multiple: false,
            id: "input-student-activity",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSelectFile && _ctx.onSelectFile(...args)))
          }, null, 32)
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(_toDisplayString("Arquivo selecionado:") + " "),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, { name: "bi-file-earmark-text-fill" }),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.form?.file[0]?.name), 1),
            _createVNode(_component_v_icon, {
              name: "md-close",
              onClick: _withModifiers(_ctx.onExcludeFile, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ])),
    _createVNode(_component_Errors, {
      errors: _ctx.v$.form.file?.$errors
    }, null, 8, ["errors"]),
    _hoisted_6,
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.textAnswer) = $event)),
      placeholder: 'Escreva aqui uma mensagem para o seu professor',
      class: _normalizeClass([[{ 'border border-h-error-500': _ctx.v$?.form?.textAnswer?.$error }], "p-inputtext h-56"]),
      style: {"resize":"none"}
    }, null, 2), [
      [_vModelText, _ctx.form.textAnswer]
    ]),
    _createVNode(_component_Errors, {
      errors: _ctx.v$?.form?.textAnswer?.$errors,
      actualLength: _ctx.form?.textAnswer?.length,
      maxLength: 1024
    }, null, 8, ["errors", "actualLength"]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_v_icon, {
        name: "io-information-circle-outline",
        scale: 1.4
      }, null, 8, ["scale"]),
      _createElementVNode("p", null, _toDisplayString("O aluno deverá enviar pelo menos um arquivo ou comentário."), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Button, {
        label: 'Enviar',
        class: "btn-primary",
        type: "submit",
        loading: _ctx.loading.studentActivity
      }, null, 8, ["loading"]),
      _createVNode(_component_Button, {
        label: 'Cancelar',
        class: "btn-outline",
        onClick: _withModifiers(_ctx.onCloseForm, ["prevent"]),
        disabled: _ctx.loading.studentActivity
      }, null, 8, ["onClick", "disabled"])
    ])
  ], 32))
}